<app-icon class="text-32" [name]="icon()"
  [class.text-32]="radioButtonGroup.size() === 'default'"
  [class.text-24]="radioButtonGroup.size() === 'small'"
  />
